import 'react';
import { jsx } from 'react/jsx-runtime';
const DEFAULT_CHEVRON_COLOR = '#000';
function ChevronRight({
  className,
  color = DEFAULT_CHEVRON_COLOR
}) {
  return /*#__PURE__*/jsx("svg", {
    className: className,
    width: "8",
    height: "11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/jsx("path", {
      d: "M7.172 5.773L2.257.823.5 2.593l3.157 3.18L.5 8.953l1.757 1.77 4.915-4.95z",
      fill: color
    })
  });
}
export { ChevronRight as default };
//# sourceMappingURL=ChevronRight.js.map
